"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeDateFilterConfigWithOverrides = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var merge_1 = require("../../../../_staging/dateFilterConfig/merge");
var validation_1 = require("../../../../_staging/dateFilterConfig/validation");
var onDateFilterConfigValidationError_1 = require("./onDateFilterConfigValidationError");
function mergeDateFilterConfigWithOverrides(ctx, cmd, config, dashboardOverrides) {
    var mergedConfig, mergedConfigValidation;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!dashboardOverrides) {
                    return [2 /*return*/, {
                            config: config,
                            source: "workspace",
                        }];
                }
                mergedConfig = merge_1.mergeDateFilterConfigs(config, dashboardOverrides);
                mergedConfigValidation = validation_1.validateDateFilterConfig(mergedConfig, false);
                if (!(mergedConfigValidation !== "Valid")) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.call(onDateFilterConfigValidationError_1.onDateFilterConfigValidationError, ctx, mergedConfigValidation, cmd.correlationId)];
            case 1:
                _a.sent();
                return [2 /*return*/, {
                        config: config,
                        source: "workspace",
                    }];
            case 2: return [2 /*return*/, {
                    config: mergedConfig,
                    source: "dashboard",
                }];
        }
    });
}
exports.mergeDateFilterConfigWithOverrides = mergeDateFilterConfigWithOverrides;
//# sourceMappingURL=mergeDateFilterConfigs.js.map